import { useMemo } from 'react';
import { backgrounds } from '../../components/media/virtualBackground/constants';
import { useBrandedVirtualBackgrounds } from './useBrandedVirtualBackgrounds';

export const useAllVirtualBackgrounds = () => {
  const brandedVirtualBackgrounds = useBrandedVirtualBackgrounds();

  return useMemo(
    () => [...brandedVirtualBackgrounds, ...backgrounds],
    [brandedVirtualBackgrounds],
  );
};
